import { DocumentsTable } from '../../../DocumentLibrary/DocumentsTable'

interface DocumentsTabProps {
  variantId: number
}

export function DocumentsTab({ variantId }: DocumentsTabProps) {
  const TABLE_KEY = `documents-modal-variant-${variantId}`

  return (
    <div style={{ height: '600px', display: 'flex', flexDirection: 'column' }}>
      <DocumentsTable
        tableKey={TABLE_KEY}
        filterIdentifier="DOCUMENTS_MODAL"
        tabType="product"
        forVariantId={variantId}
        excludeImages
        disableUrlPagination
        disableExportButton
        hideColumnSelector
        searchPlaceholder="Search by name..."
        defaultColumnVisibility={{
          name: true,
          tags: true,
          product_name: false,
          variant_name: false,
          company_name: false,
          size: true,
          created: true,
          modified: false,
          created_by_name: true,
          version_number: false,
          actions: true,
        }}
      />
    </div>
  )
}
